<template>
    <div>
        <div v-if="loading">
            <em>Loading...</em>
        </div>
        <table class="table" v-else-if="orderItems && orderItems.length">
            <thead>
                <tr>
                    <th>Vendor</th>
                    <th>Date</th>
                    <th class="text-right">Quantity</th>
                    <th>Status</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <OrderItemsTableRow v-for="orderItem in orderItems" :orderItem="orderItem" :key="orderItem.id" />
            </tbody>
        </table>
        <div v-else>
            <em>No order items were found for this product.</em>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import OrderItemsTableRow from './OrderItemsTableRow';

export default {
    components: { OrderItemsTableRow },
    props: ['productId', 'orderItemIds'],
    data() {
        return {
            ids: null,
            loading: false,
        };
    },
    computed: {
        ...mapState('data', {
            orderItems(state) {
                if (this.displayedOrderItemIds)
                    return this.displayedOrderItemIds.map(id => state.orderItems.byId[id]).filter(i => i);
            },
        }),
        displayedOrderItemIds() {
            return this.orderItemIds || this.ids;
        },
    },
    watch: {
        productId: {
            handler: 'loadData',
            immediate: true,
        },
    },
    methods: {
        ...mapActions('data', ['getOrderItems']),
        async loadData() {
            if (!this.productId) {
                this.ids = null;
                return;
            }

            this.loading = true;

            this.ids = await this.getOrderItems({ productId: this.productId });

            this.loading = false;
        },
    },
};
</script>
